"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Truncates the result set based on `maxResults` and returns the new set.
 */
function getTruncatedOptions(options, maxResults) {
  if (!maxResults || maxResults >= options.length) {
    return options;
  }

  return options.slice(0, maxResults);
}

var _default = getTruncatedOptions;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-typeahead/lib/utils/getTruncatedOptions.js
// module id = 2325
// module chunks = 0